__turbopack_context__.v({
  "itemsContainer": "jHxsXq_itemsContainer",
  "title": "jHxsXq_title",
  "tooltip": "jHxsXq_tooltip",
  "wrapper": "jHxsXq_wrapper",
});
